const bad = () => `<svg width="31" height="31" viewBox="0 0 31 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<ellipse cx="15.1313" cy="20.1738" rx="8.34806" ry="3.8262" fill="url(#paint0_linear_715_5101)"/>
<path d="M23.2293 20.1738C23.2293 21.0731 22.4231 21.9678 20.9301 22.6521C19.4589 23.3263 17.409 23.75 15.1313 23.75C12.8536 23.75 10.8036 23.3263 9.33246 22.6521C7.83947 21.9678 7.0332 21.0731 7.0332 20.1738C7.0332 19.2744 7.83947 18.3798 9.33246 17.6955C10.8036 17.0212 12.8536 16.5976 15.1313 16.5976C17.409 16.5976 19.4589 17.0212 20.9301 17.6955C22.4231 18.3798 23.2293 19.2744 23.2293 20.1738Z" stroke="white" stroke-opacity="0.8" stroke-width="0.5"/>
<g filter="url(#filter0_d_715_5101)">
<circle cx="15.1307" cy="11.1307" r="11.1307" fill="url(#paint1_radial_715_5101)"/>
<circle cx="15.1307" cy="11.1307" r="11.1307" fill="url(#paint2_linear_715_5101)"/>
<circle cx="15.1307" cy="11.1307" r="10.6307" stroke="#D67504" stroke-opacity="0.27"/>
</g>
<g filter="url(#filter1_di_715_5101)">
<path d="M13.0439 17.3918C14.8021 16.626 15.721 16.5962 17.218 17.3918" stroke="#823423" stroke-width="2" stroke-linecap="round"/>
</g>
<rect x="9.56543" y="10.4351" width="2.78269" height="11.8264" rx="1" fill="url(#paint3_linear_715_5101)"/>
<rect x="17.9131" y="10.4351" width="2.78269" height="11.8264" rx="1" fill="url(#paint4_linear_715_5101)"/>
<g opacity="0.3" filter="url(#filter2_di_715_5101)">
<path d="M12.3478 5.56604C12.149 5.79793 11.4533 6.26171 10.2607 6.26171" stroke="#823423" stroke-width="2" stroke-linecap="round"/>
</g>
<g opacity="0.3" filter="url(#filter3_di_715_5101)">
<path d="M17.913 5.56604C18.1117 5.79793 18.8074 6.26171 20 6.26171" stroke="#823423" stroke-width="2" stroke-linecap="round"/>
</g>
<g filter="url(#filter4_di_715_5101)">
<path d="M9.91309 10.0865H12.0001" stroke="#823423" stroke-width="2" stroke-linecap="round"/>
</g>
<g filter="url(#filter5_di_715_5101)">
<path d="M18.2617 10.0865H20.3487" stroke="#823423" stroke-width="2" stroke-linecap="round"/>
</g>
<defs>
<filter id="filter0_d_715_5101" x="0" y="0" width="30.2617" height="30.2615" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="2"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.9 0 0 0 0 0.6165 0 0 0 0 0.19125 0 0 0 0.33 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5101"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5101" result="shape"/>
</filter>
<filter id="filter1_di_715_5101" x="11.0439" y="15.8062" width="8.17383" height="4.58582" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5101"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5101" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5101"/>
</filter>
<filter id="filter2_di_715_5101" x="8.26074" y="4.56601" width="6.08691" height="4.69571" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5101"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5101" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5101"/>
</filter>
<filter id="filter3_di_715_5101" x="15.9131" y="4.56601" width="6.08691" height="4.69571" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5101"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5101" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5101"/>
</filter>
<filter id="filter4_di_715_5101" x="7.91309" y="9.08655" width="6.08691" height="4" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5101"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5101" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5101"/>
</filter>
<filter id="filter5_di_715_5101" x="16.2617" y="9.08655" width="6.08691" height="4" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5101"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5101" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5101"/>
</filter>
<linearGradient id="paint0_linear_715_5101" x1="15.1313" y1="16.3476" x2="15.1313" y2="24" gradientUnits="userSpaceOnUse">
<stop stop-color="#85EDED"/>
<stop offset="1" stop-color="#7AFFFF" stop-opacity="0.65"/>
</linearGradient>
<radialGradient id="paint1_radial_715_5101" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(15.1307) rotate(90) scale(22.2615)">
<stop stop-color="#EED919"/>
<stop offset="1" stop-color="#F1BE08"/>
</radialGradient>
<linearGradient id="paint2_linear_715_5101" x1="15.1307" y1="0" x2="15.1307" y2="22.2615" gradientUnits="userSpaceOnUse">
<stop stop-color="white" stop-opacity="0.52"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint3_linear_715_5101" x1="10.9568" y1="10.4351" x2="10.9568" y2="22.2615" gradientUnits="userSpaceOnUse">
<stop stop-color="#85EDED"/>
<stop offset="1" stop-color="#85EDED" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint4_linear_715_5101" x1="19.3044" y1="10.4351" x2="19.3044" y2="22.2615" gradientUnits="userSpaceOnUse">
<stop stop-color="#85EDED"/>
<stop offset="1" stop-color="#85EDED" stop-opacity="0"/>
</linearGradient>
</defs>
</svg>
`;

const okay = () => `<svg width="32" height="32" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_715_5131)">
<circle cx="16" cy="12" r="12" fill="url(#paint0_radial_715_5131)"/>
<circle cx="16" cy="12" r="12" fill="url(#paint1_linear_715_5131)"/>
<circle cx="16" cy="12" r="11.5" stroke="#D67504" stroke-opacity="0.27"/>
</g>
<g filter="url(#filter1_di_715_5131)">
<path d="M13 18V18C14.7176 16.4971 17.2824 16.4971 19 18V18" stroke="#823423" stroke-width="2" stroke-linecap="round"/>
</g>
<g opacity="0.3" filter="url(#filter2_di_715_5131)">
<path d="M13 7.5C12.7857 7.75 12.0357 8.25 10.75 8.25" stroke="#823423" stroke-width="2" stroke-linecap="round"/>
</g>
<g filter="url(#filter3_di_715_5131)">
<rect width="2.25" height="3" rx="1.125" transform="matrix(-1 0 0 1 21.25 9.75)" fill="#823423"/>
</g>
<g filter="url(#filter4_di_715_5131)">
<rect width="2.25" height="3" rx="1.125" transform="matrix(-1 0 0 1 13 9.75)" fill="#823423"/>
</g>
<g opacity="0.3" filter="url(#filter5_di_715_5131)">
<path d="M19 7.5C19.2143 7.75 19.9643 8.25 21.25 8.25" stroke="#823423" stroke-width="2" stroke-linecap="round"/>
</g>
<defs>
<filter id="filter0_d_715_5131" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="2"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.9 0 0 0 0 0.6165 0 0 0 0 0.19125 0 0 0 0.33 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5131"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5131" result="shape"/>
</filter>
<filter id="filter1_di_715_5131" x="11" y="15.8728" width="10" height="5.1272" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5131"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5131" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5131"/>
</filter>
<filter id="filter2_di_715_5131" x="8.75" y="6.49997" width="6.25" height="4.75003" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5131"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5131" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5131"/>
</filter>
<filter id="filter3_di_715_5131" x="18" y="9.75" width="4.25" height="5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5131"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5131" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5131"/>
</filter>
<filter id="filter4_di_715_5131" x="9.75" y="9.75" width="4.25" height="5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5131"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5131" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5131"/>
</filter>
<filter id="filter5_di_715_5131" x="17" y="6.49997" width="6.25" height="4.75003" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5131"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5131" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5131"/>
</filter>
<radialGradient id="paint0_radial_715_5131" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(16) rotate(90) scale(24)">
<stop stop-color="#EED919"/>
<stop offset="1" stop-color="#F1BE08"/>
</radialGradient>
<linearGradient id="paint1_linear_715_5131" x1="16" y1="0" x2="16" y2="24" gradientUnits="userSpaceOnUse">
<stop stop-color="white" stop-opacity="0.52"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
</defs>
</svg>
`;

const fair = () => `<svg width="32" height="32" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_715_5121)">
<circle cx="16" cy="12" r="12" fill="url(#paint0_radial_715_5121)"/>
<circle cx="16" cy="12" r="12" fill="url(#paint1_linear_715_5121)"/>
<circle cx="16" cy="12" r="11.5" stroke="#D67504" stroke-opacity="0.27"/>
</g>
<g filter="url(#filter1_di_715_5121)">
<path d="M13 17.25H19" stroke="#EB5D3E" stroke-width="2" stroke-linecap="round"/>
</g>
<g filter="url(#filter2_di_715_5121)">
<rect x="10.75" y="8.25" width="2.25" height="3.75" rx="1.125" fill="#823423"/>
</g>
<g filter="url(#filter3_di_715_5121)">
<rect x="19" y="8.25" width="2.25" height="3.75" rx="1.125" fill="#823423"/>
</g>
<defs>
<filter id="filter0_d_715_5121" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="2"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.9 0 0 0 0 0.6165 0 0 0 0 0.19125 0 0 0 0.33 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5121"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5121" result="shape"/>
</filter>
<filter id="filter1_di_715_5121" x="11" y="16.25" width="10" height="4" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5121"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5121" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5121"/>
</filter>
<filter id="filter2_di_715_5121" x="9.75" y="8.25" width="4.25" height="5.75" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5121"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5121" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5121"/>
</filter>
<filter id="filter3_di_715_5121" x="18" y="8.25" width="4.25" height="5.75" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5121"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5121" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5121"/>
</filter>
<radialGradient id="paint0_radial_715_5121" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(16) rotate(90) scale(24)">
<stop stop-color="#EED919"/>
<stop offset="1" stop-color="#F1BE08"/>
</radialGradient>
<linearGradient id="paint1_linear_715_5121" x1="16" y1="0" x2="16" y2="24" gradientUnits="userSpaceOnUse">
<stop stop-color="white" stop-opacity="0.52"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
</defs>
</svg>
`;

const good = () => `<svg width="32" height="32" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_715_5116)">
<circle cx="16" cy="12" r="12" fill="url(#paint0_radial_715_5116)"/>
<circle cx="16" cy="12" r="12" fill="url(#paint1_linear_715_5116)"/>
<circle cx="16" cy="12" r="11.5" stroke="#D67504" stroke-opacity="0.27"/>
</g>
<g filter="url(#filter1_di_715_5116)">
<rect width="2.25" height="3" rx="1.125" transform="matrix(-1 0 0 1 21.25 6.75)" fill="#823423"/>
</g>
<g filter="url(#filter2_di_715_5116)">
<rect width="2.25" height="3" rx="1.125" transform="matrix(-1 0 0 1 13 6.75)" fill="#823423"/>
</g>
<g filter="url(#filter3_di_715_5116)">
<path d="M12.25 15V15C14.6573 15.9629 17.3427 15.9629 19.75 15V15" stroke="#EB5D3E" stroke-width="3.5" stroke-linecap="round"/>
</g>
<defs>
<filter id="filter0_d_715_5116" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="2"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.9 0 0 0 0 0.6165 0 0 0 0 0.19125 0 0 0 0.33 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5116"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5116" result="shape"/>
</filter>
<filter id="filter1_di_715_5116" x="18" y="6.75" width="4.25" height="5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5116"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5116" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5116"/>
</filter>
<filter id="filter2_di_715_5116" x="9.75" y="6.75" width="4.25" height="5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5116"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5116" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5116"/>
</filter>
<filter id="filter3_di_715_5116" x="9.5" y="13.2495" width="13" height="6.22266" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5116"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5116" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5116"/>
</filter>
<radialGradient id="paint0_radial_715_5116" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(16) rotate(90) scale(24)">
<stop stop-color="#EED919"/>
<stop offset="1" stop-color="#F1BE08"/>
</radialGradient>
<linearGradient id="paint1_linear_715_5116" x1="16" y1="0" x2="16" y2="24" gradientUnits="userSpaceOnUse">
<stop stop-color="white" stop-opacity="0.52"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
</defs>
</svg>
`;

const excellent = () => `<svg width="32" height="32" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_715_5126)">
<circle cx="16" cy="12" r="12" fill="url(#paint0_radial_715_5126)"/>
<circle cx="16" cy="12" r="12" fill="url(#paint1_linear_715_5126)"/>
<circle cx="16" cy="12" r="11.5" stroke="#D67504" stroke-opacity="0.27"/>
</g>
<g filter="url(#filter1_di_715_5126)">
<path d="M10.75 9V9C11.3125 8.25 12.4375 8.25 13 9V9" stroke="#823423" stroke-width="2" stroke-linecap="round"/>
</g>
<g filter="url(#filter2_di_715_5126)">
<path d="M19 9V9C19.5625 8.25 20.6875 8.25 21.25 9V9" stroke="#823423" stroke-width="2" stroke-linecap="round"/>
</g>
<g filter="url(#filter3_di_715_5126)">
<path d="M16 19.5C12.8061 19.5 10 17.3966 10 14.8018C10 13.5791 11.0897 12.6278 12.3356 12.7628L13.7123 12.912C15.2328 13.0768 16.7672 13.0768 18.2877 12.912L19.6644 12.7628C20.9103 12.6278 22 13.5791 22 14.8018C22 17.3966 19.1939 19.5 16 19.5Z" fill="#EB5D3E"/>
</g>
<defs>
<filter id="filter0_d_715_5126" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="2"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.9 0 0 0 0 0.6165 0 0 0 0 0.19125 0 0 0 0.33 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5126"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5126" result="shape"/>
</filter>
<filter id="filter1_di_715_5126" x="8.75" y="7.4375" width="6.25" height="4.56256" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5126"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5126" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5126"/>
</filter>
<filter id="filter2_di_715_5126" x="17" y="7.4375" width="6.25" height="4.56256" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5126"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5126" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5126"/>
</filter>
<filter id="filter3_di_715_5126" x="9" y="12.75" width="14" height="8.75" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_5126"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_715_5126" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_715_5126"/>
</filter>
<radialGradient id="paint0_radial_715_5126" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(16) rotate(90) scale(24)">
<stop stop-color="#EED919"/>
<stop offset="1" stop-color="#F1BE08"/>
</radialGradient>
<linearGradient id="paint1_linear_715_5126" x1="16" y1="0" x2="16" y2="24" gradientUnits="userSpaceOnUse">
<stop stop-color="white" stop-opacity="0.52"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
</defs>
</svg>
`;

export { bad, okay, fair, good, excellent };
